"use client";
import { makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { TabView, TabViewInfo } from "../components/TabView";
import { useSearchParams } from "react-router-dom";
import ChapterImagesList from "../components/image/ChapterImagesList";
import ActivityImagesTabView from "../components/image/ActivityImagesTabView";
import { ConstrainedContent } from "../components/layout/ConstrainedContent";
import { useGetUserAccessLevel } from "../hooks/useGetUserAccessLevel";

const useClasses = makeStyles({
  root: {
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
});

function MediaPage() {
  const classes = useClasses();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const accessLevel = useGetUserAccessLevel();

  const view =
    searchParams.get("view") === "chapterimages" && accessLevel >= 4
      ? "chapterimages"
      : "activityimages";

  const tabInfos: TabViewInfo[] = [
    { text: t("activityImages"), value: "activityimages" },
  ];

  if (accessLevel >= 4) {
    tabInfos.push({ text: t("chapterImages"), value: "chapterimages" });
  }

  return (
    <div className={classes.root}>
      <ConstrainedContent>
        <h1>{t("media")}</h1>
        <TabView
          tabInfos={tabInfos}
          defaultTabValue={view}
          onTabChange={() => undefined}
        />
      </ConstrainedContent>

      {view === "activityimages" && <ActivityImagesTabView />}

      {view === "chapterimages" && <ChapterImagesList />}
    </div>
  );
}

export default MediaPage;
